import React, { Component } from "react";
import "./index.scss";
import { ReactComponent as VfulfillLogo } from "../../../../../assets/images/icons/vFULLfillLogo.svg";
import { ReactComponent as RightLogo } from "../../../../../assets/images/icons/greenroundcorrect.svg";
export default class TabFirstContainer extends Component {
  render() {
    return (
      <div className="tabFirstContainer">
        <div className="logocontainer">
          <VfulfillLogo />
        </div>
        <div className="bar-container">
          <div className="bar">
            <span className="right-logo">
              <RightLogo />
            </span>{" "}
            <span className="data">100% Managed Platform</span>
          </div>
          <div className="bar">
            <span className="right-logo">
              <RightLogo />
            </span>{" "}
            <span className="data">Private Label Packaging</span>
          </div>
          <div className="bar">
            <span className="right-logo">
              <RightLogo />
            </span>{" "}
            <span className="data"> Warehousing & Fulfillment</span>
          </div>
          <div className="bar">
            <span className="right-logo">
              <RightLogo />
            </span>{" "}
            <span className="data"> Express Shipping</span>
          </div>
        </div>
      </div>
    );
  }
}
